import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../Grid';
import GridItem from '../GridItem';
import makeClassName from 'shared-utils/src/makeClassName';
import createStyle from 'shared-utils/src/createStyle';
import { Icon } from 'shared-vectors';
import FilterArrowDsk from 'shared-vectors/icons/Caret';
import style, { mainCls } from './style';

const useStyles = createStyle(style);

const chooseIcon = ({ name, height, width, rotate }) => {
  const def = '24px';
  const cls = `ml--s ${rotate ? `rotate--${rotate}` : ''}`
  switch (name) {
    case 'filterArrow':
      return (
        <Icon
          name={FilterArrowDsk}
          width={width || def}
          height={height || def}
          className={cls}
        />
      );

    default:
      return null;
  }
};
const PillButton = ({
  key,
  highlatedLabel,
  label,
  iconName,
  action,
  type,
  clsIcon,
}) => {
  const cls = useStyles();
  const icon = chooseIcon({ name: iconName, ...clsIcon });

  const clsCnt = makeClassName([
    cls[mainCls],
    cls[`${mainCls}${type ? `__${type}` : '__default'}`],
    'pr--m pl--m pt--s pb--s c-txt--f0',
  ]);
  return (
    <button key={key} type="button" onClick={action} className={clsCnt}>
      <div className={`${mainCls}__cnt-btns`}>
        <span className="tp-w--l tp-s--l">{highlatedLabel}</span>
        <span className="tp-w--m tp-s--l">&nbsp;{label}</span>
        {icon}
      </div>
    </button>
  );
};

PillButton.propTypes = {
  label: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
};

export default PillButton;
